import { requestModuleCommand, resetModuleCommand } from 'owa-calendar-module-command';
import { orchestrator } from 'satcheljs';
import {
    showItemDeleteModal,
    hideItemDeleteModal,
    showMeetingDndModal,
    hideMeetingDndModal,
} from 'owa-calendar-modal-actions';
import { openMobilityCompose, closeMobilityCompose } from 'owa-mobility-compose';
import {
    onShowFullCompose,
    onCloseFullCompose,
    onShowQuickCompose,
    onCloseQuickCompose,
} from 'owa-calendar-compose-form-store';
import { showItemPeek, hideItemPeek } from 'owa-calendar-peek';
import {
    showItemContextMenu,
    hideItemContextMenu,
    showSurfaceContextMenu,
    hideSurfaceContextMenu,
} from 'owa-calendar-surface-contextmenu-actions';
import { onHideReadingPane, onShowReadingPane } from 'owa-calendar-reading-pane-actions';
import { registerQuickComposeStiches } from './registerQuickComposeStiches';

// TODO: VSO #89735 Audit boundary between surface and board
// Many of these should probably be converted to lazy orchestrators or split/grouped by applicable view type

// Subscribes to actions for updating module command
export function registerModuleStitches() {
    orchestrator(showItemPeek, function () {
        requestModuleCommand('Open_ItemPeek');
    });

    orchestrator(hideItemPeek, function () {
        resetModuleCommand('Open_ItemPeek');
    });
    orchestrator(showItemContextMenu, () => {
        requestModuleCommand('Open_ItemContextMenu');
    });
    orchestrator(hideItemContextMenu, () => {
        resetModuleCommand('Open_ItemContextMenu');
    });
    orchestrator(showSurfaceContextMenu, () => {
        requestModuleCommand('Open_SurfaceContextMenu');
    });
    orchestrator(hideSurfaceContextMenu, () => {
        resetModuleCommand('Open_SurfaceContextMenu');
    });
    orchestrator(onShowReadingPane, () => requestModuleCommand('Open_ReadPanel'));
    orchestrator(onHideReadingPane, () => {
        resetModuleCommand('Open_ReadPanel');
    });

    orchestrator(onShowQuickCompose, () => requestModuleCommand('Open_QuickCompose'));
    orchestrator(onCloseQuickCompose, () => resetModuleCommand('Open_QuickCompose'));
    orchestrator(showItemDeleteModal, () => requestModuleCommand('Open_ItemDeleteModal'));
    orchestrator(hideItemDeleteModal, () => resetModuleCommand('Open_ItemDeleteModal'));
    orchestrator(showMeetingDndModal, () => requestModuleCommand('Open_MeetingDndModal'));
    orchestrator(hideMeetingDndModal, () => resetModuleCommand('Open_MeetingDndModal'));

    orchestrator(onShowFullCompose, () => requestModuleCommand('Open_FullComposeForm'));
    orchestrator(onCloseFullCompose, () => resetModuleCommand('Open_FullComposeForm'));
    orchestrator(openMobilityCompose, () => requestModuleCommand('Open_MobilityCompose'));
    orchestrator(closeMobilityCompose, () => resetModuleCommand('Open_MobilityCompose'));

    registerQuickComposeStiches();
}
